module.exports = __webpack_public_path__ + "static/media/Download.169aa97e.svg";